import { useState } from "react";

export default function useModal(initialState) {
  const [isOpen, setOpen] = useState(initialState ?? false);

  const toggleModal = () => {
    setOpen(prev => !prev);
  };

  return [isOpen, setOpen, toggleModal];
}
